export const createDragHandlers = (setDragActiveState) => ({
  onDragEnter: (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActiveState(true);
  },
  onDragLeave: (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActiveState(false);
  },
  onDragOver: (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActiveState(true);
  }
});

export const createDropHandler = (setDragActiveState, onFileAccepted) => (e) => {
  e.preventDefault();
  e.stopPropagation();
  setDragActiveState(false);
  if (e.dataTransfer.files && e.dataTransfer.files[0]) {
    onFileAccepted(e.dataTransfer.files[0]);
  }
};